import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type { PutUpdatePasswordParams } from "./apiEcms.types";

// Change password when already connected
const putUpdatePassword = (params: PutUpdatePasswordParams) =>
  apiEcmsHttp.put("/update-password", params);

export const usePutUpdatePassword = () => {
  const { t } = useCustomTranslation(["main", "common"]);

  return useMutation({
    mutationFn: putUpdatePassword,
    onSuccess: () => {
      addToast({
        variant: "success",
        title: t("settings.resetPassword.success"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("form.error.generic", { ns: "common" }),
      });
    },
    retry: false,
    mutationKey: [QUERY_KEYS.PASSWORD_UPDATE],
  });
};
